import React from 'react';
import PropTypes from 'prop-types';
import { DtpButtonIcon } from 'dtp-react-components';
import Masks from '../../../utils/masks';
import Dependentes from './Dependentes';
import {
  Button,
  Input,
  Grid,
  DataGrid,
  ControleDocumentos,
} from '../../../components/index';
import ResultadoAnalise from '../ResultadoAnalise';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import CalculoCompensacao from '../Aposentadoria/CalculoCompensacao';
import * as constantes from '../../../utils/constants';
import SolicitanteDestinatario from '../SolicitanteDestinatario';
import Destinacao from '../Destinacao';
import UploadArquivos from '../UploadArquivos';
import { habilitarUploadNaConsultaDoRequerimento } from '../../../utils/helpers';
import SegregacaoDeMassa from '../SegregacaoDeMassa';
import User from '../../../domain/User';
import ModalAlteracaoDataCessacao from '../ModalAlteracaoDataCessacao';

const camposDesabilitadosAlteracaoRequerimento = [
  'cpf',
  'nome',
  'destinatario',
  'matricula',
  // 'numeroBeneficio',
];

const DadosRequerimentoPensao = (props) => {
  // Torna a lista de documentos adequada ao formato do componente de documentos
  const handleDocuments = () => {
    let documentos = [];
    if (props.estadoFormulario.requerimento.documentosProbatorios &&
      props.estadoFormulario.requerimento.documentosProbatorios.length > 0) {
      documentos = props.estadoFormulario.requerimento.documentosProbatorios.map(docs => ({
        key: docs.codigo,
        documentType: docs.tipoDocumento,
      }));
    }
    return documentos;
  };

  /**
   * Campos devem estar desabilitados sempre que:
   *  - Acao diferente de novo e cumprir-exigencia
   *  - Se em estado cumprir-exigencia, for considerado chave ou nao for validado no CNIS
   *  - Se em estado novo, for buscado no CNIS
   */
  const verificaSeCampoDesabilitado = (name) => {
    const { acao } = { ...props.estadoFormulario };
    if (!['cumprir-exigencia', 'novo', 'indeferidos'].includes(acao)) {
      return true;
    }
    if (acao === 'cumprir-exigencia') {
      if ((name === 'rendaMensalInicial') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        const { isRmiZerada, rendaMensalInicialRequest } = { ...props.estadoFormulario };
        if (isRmiZerada === true ||
          (rendaMensalInicialRequest !== null && rendaMensalInicialRequest === 0)) {
          return false;
        }
      }

      return camposDesabilitadosAlteracaoRequerimento.includes(name) ||
        props.camposCnis.includes(name) ||
        (props.camposCentralService.includes(name) && props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']));
      // return camposDesabilitadosAlteracaoRequerimento.includes(name);
    }
    if (acao === 'novo') {
      if ((name === 'rendaMensalInicial') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        const { isRmiZerada, rendaMensalInicialRequest } = { ...props.estadoFormulario };
        if (isRmiZerada === true ||
          (rendaMensalInicialRequest !== null && rendaMensalInicialRequest === 0)) {
          return false;
        }
      }

      return props.camposCnis.includes(name) ||
        (props.camposCentralService.includes(name) &&
        props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']));
      // return props.camposCnis.includes(name);
    }

    if (acao === 'indeferidos') {
      const { isRmiZerada } = { ...props.estadoFormulario };
      if ((['numeroBeneficio'].includes(name) &&
        props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps'])) ||
        ((isRmiZerada && name === 'rendaMensalInicial') &&
        props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps']))) {
        return false;
      }

      if (['dataInicioBeneficio', 'dataInicioPagamentoBeneficio',
        'dataCessacaoBeneficio', 'rendaMensalInicial', 'dataHomologacaoTribunalContas'].includes(name) &&
        props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps'])) {
        return false;
      }

      return true;
    }

    return false;
  };

  let pesquisarNB;

  if (['novo', 'cumprir-exigencia', 'indeferidos'].includes(props.estadoFormulario.acao)) {
    pesquisarNB = (
      <Button
        title="Pesquisar benefício"
        onClick={() => props.handleSearchNBButton()}
        hint="Pesquisar benefício"
      />
    );
  }

  /**
   * Teste as condicoes para definir dentre os campos alternativos Matricula e Numero de Beneficio
   * qual deve ser exibido.
   */
  const controleCampoAlternativos = (campo) => {
    switch (campo) {
      case 'matricula':
        if (props.estadoFormulario.acao !== 'novo') {
          // Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
          if (props.estadoFormulario.requerimento.matricula) {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao de requerimento, apenas RPPS deve possuir campo Matricula
        return ['requerer-compensacao-rpps'];

      case 'numeroBeneficio':
        if (!['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
          if (props.estadoFormulario.requerimento.numeroBeneficio) {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao de requerimento, apenas RGPS deve possuir campo Numero de Beneficio
        return ['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'];

      case 'dataHomologacaoTribunalContas':
        if (!['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver diferente de em exigencia ou novo,
          // mostrar data de homologacao quando solicitante for RPPS
          if (props.estadoFormulario.requerimento.solicitante &&
            props.estadoFormulario.requerimento.solicitante.codigo !== '01000') {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao ou exigencia de requerimento, apenas RPPS deve ver campo
        return ['requerer-compensacao-rpps'];

      case 'dataCreditoPagamento':
        if (!['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver diferente de em exigencia ou novo,
          // mostrar data de homologacao quando solicitante for RGPS
          if (props.estadoFormulario.requerimento.solicitante &&
            props.estadoFormulario.requerimento.solicitante.codigo === '01000') {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
        return ['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'];

      case 'numeroBeneficioAposentadoria':
        if (!['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver diferente de em exigencia ou novo,
          // mostrar o numero do beneficio de aposentaria quando o solicitante for RGPS
          if (props.estadoFormulario.requerimento.solicitante &&
            props.estadoFormulario.requerimento.solicitante.codigo === '01000') {
            return ['requerer-compensacao-rpps', 'requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'];
          }
          return [];
        }
        // Quando for criacao ou exigencia de requerimento, apenas RGPS e DCOMP devem ver campo
        return ['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'];
      case 'idUOMantenedora':
        if (!['novo', 'cumprir-exigencia', 'realizar-analise'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver diferente de em exigencia ou novo,
          // mostrar idUOMantenedora quando solicitante for RGPS
          if ((props.estadoFormulario.requerimento.solicitante &&
            props.estadoFormulario.requerimento.solicitante.codigo === '01000')) {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
        return ['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'];

      default:
        return [];
    }
  };

  let resultadoAnalise;
  if (props.estadoFormulario.acao === 'realizar-analise') {
    resultadoAnalise = (
      <ProtectedItem allowedPermissions={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp']}>
        <ResultadoAnalise
          alteraEstado={props.alteraEstadoRequerimento}
          handleChange={props.handleChange}
          requerimento={props.estadoFormulario.requerimento}
          userData={props.auth.userData}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          inIndefericaoAnalise={props.estadoFormulario.inIndefericaoAnalise}
          atualizarDocumentosProbatorios={props.atualizarDocumentosProbatorios}
          motivosIndeferimentoControle={props.estadoFormulario.motivosIndeferimentoControle}
          handleChangeTipoDocumento={props.handleChangeTipoDocumento}
          tipoDocumento={props.estadoFormulario.tipoDocumento}
          handleChangeFile={props.handleChangeFile}
        />
      </ProtectedItem>
    );
  }

  let documentosProbatorios;
  if (props.tiposDocumentos.length > 0) {
    documentosProbatorios = (
      <ControleDocumentos
        tiposDocumentos={props.tiposDocumentos}
        documents={handleDocuments()}
        protocolo={props.match.params.protocolo}
        auth={props.auth}
        acao={props.acao}
        requerimento={props.estadoFormulario.requerimento}
        atualizarDocumentosProbatorios={props.atualizarDocumentosProbatorios}
        tipoRequerimento={props.estadoFormulario.tipoRequerimento}
      />
    );
  }

  let calculoCompensacao;
  if (props.estadoFormulario.acao === 'consulta') {
    calculoCompensacao = (
      <CalculoCompensacao
        handleChange={props.handleChange}
        requerimento={props.estadoFormulario.requerimento}
      />
    );
  }

  let { destinatario } = { ...props.estadoFormulario.requerimento };
  if (destinatario) {
    if (typeof (destinatario) === 'object') {
      destinatario = destinatario.codigo;
    }
  }
  let opcoesDestinatario = null;
  if (props.estadoFormulario.destinatarioLabel.length > 0) {
    opcoesDestinatario = (
      <Grid cols="4 4 4 4">
        <Input
          required
          disabled={verificaSeCampoDesabilitado('destinatario')}
          itemList={props.estadoFormulario.destinatarioLabel}
          touched={props.estadoFormulario.touched}
          label="Destinatário"
          onChange={(props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps']) &&
          Object.keys(props.estadoFormulario.matriculaLabel).length !== 0) ?
          e => props.handleChangeDestinatario(e, 'destinatario') :
          e => props.handleChange(e, 'destinatario')}
          placeholder="Selecione o destinatário"
          value={destinatario}
          error={!props.estadoFormulario.validadeCampos.destinatario}
          custom
        />
      </Grid>
    );
  }

  let opcoesMatricula = null;
  if (props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps']) &&
  (Object.keys(props.estadoFormulario.matriculaLabel).length !== 0)) {
    opcoesMatricula = (
      <Grid cols="4 4 4 4">
        <Input
          disabled
          label="Matricula"
          integer
          value={props.estadoFormulario.requerimento.matricula}
          touched={props.estadoFormulario.touched}
        />
      </Grid>
    );
  } else if (Object.keys(props.estadoFormulario.matriculaLabel).length !== 0
      && props.estadoFormulario.matriculaLabel.constructor === Object) {
    opcoesMatricula = (
      <ProtectedItem allowedPermissions={controleCampoAlternativos('matricula')}>
        <Grid cols="4 4 4 4">
          <Input
            disabled={verificaSeCampoDesabilitado('matricula')}
            itemList={props.estadoFormulario.requerimento.destinatario
              ? props.estadoFormulario
                .matriculaLabel[props.estadoFormulario.requerimento.destinatario] : []}
            touched={props.estadoFormulario.touched}
            label="Matrícula Regime Instituidor"
            onChange={e => props.handleChange(e, 'matricula')}
            placeholder="Selecione a matrícula"
            value={props.estadoFormulario.requerimento.matricula}
            error={'matricula' in props.estadoFormulario.validadeCampos
              ? !props.estadoFormulario.validadeCampos.matricula : false}
            required
            custom
          />
        </Grid>
      </ProtectedItem>
    );
  }

  let botaoAlterarDataCessacao;
  if ((props.estadoFormulario.requerimento && props.estadoFormulario.requerimento.solicitante) &&
    (props.estadoFormulario.acao === 'consulta' && [4, 5, 13].includes(props.estadoFormulario.requerimento.estado)) &&
      ((props.estadoFormulario.requerimento.solicitante.cnpj === User.logged().cnpjDoPapel()) ||
      ((props.estadoFormulario.requerimento.solicitante.codigo === '01000' && User.logged().isRGPS())))) {
    botaoAlterarDataCessacao = (
      <DtpButtonIcon
        icon="ico-pencil"
        className="icone"
        accessibilityName="Alterar data de cessação"
        onClick={() => props.handleModalAlteraDataCessacao()}
        hint="Alterar data de cessação"
      />
    );
  }

  let pesquisar;
  if (['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
    pesquisar = (
      <Button
        title="Pesquisar"
        onClick={() => props.handleSearchButton()}
        hint="Pesquisar dados pessoais"
      />
    );
  }

  return (
    <React.Fragment>
      { (props.acao !== 'indeferidos' && props.acao !== 'novo') &&
        <SolicitanteDestinatario requerimento={props.estadoFormulario.requerimento} />
      }

      { props.estadoFormulario.requerimento.solicitanteOrigem &&
      <DataGrid title="Detalhes do Solicitante" icon="ico-user" >
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              disabled
              label="Solicitante de Origem"
              value={props.estadoFormulario.requerimento.solicitanteOrigem.nome}
              required
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              disabled
              label="Código do Solicitante"
              value={props.estadoFormulario.requerimento.solicitanteOrigem.codigo}
              required
            />
          </Grid>
        </div>
      </DataGrid>
      }

      <DataGrid title="Dados do Requerimento de Aposentadoria" icon="ico-user" >
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('cpf')}
              cpf
              error={!props.estadoFormulario.validadeCampos.cpf}
              integer
              label="CPF"
              mask={Masks.cpf}
              onChange={e => props.handleChange(e, 'cpf')}
              required
              showMask
              touched={props.estadoFormulario.touched || props.estadoFormulario.cpfTouched}
              value={props.estadoFormulario.requerimento.cpf}
            />
          </Grid>
          {pesquisar}
        </div>
        <div className="row">
          <ProtectedItem allowedPermissions={controleCampoAlternativos('numeroBeneficioAposentadoria')}>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Número do Benefício de Aposentadoria"
                integer
                value={props.estadoFormulario.requerimento.numeroBeneficioAposentadoria}
                touched={props.estadoFormulario.touched}
              />
            </Grid>
          </ProtectedItem>
        </div>
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled={verificaSeCampoDesabilitado('nome')}
              label="Nome"
              onChange={e => props.handleChange(e, 'nome')}
              value={props.estadoFormulario.requerimento.nome}
            />
          </Grid>
          {opcoesDestinatario}
          {opcoesMatricula}
        </div>
        {(props.estadoFormulario.destinatarioLabel.length > 0) &&
          <div className="row">
            <SegregacaoDeMassa estadoFormulario={props.estadoFormulario} />
          </div>
        }
      </DataGrid>

      { props.acao === 'indeferidos' && props.estadoFormulario.requerimento.solicitante &&
        <Destinacao
          requerimento={props.estadoFormulario.requerimento}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          handleChange={props.handleChange}
        />
      }

      <DataGrid title="Dados de Benefício de Pensão" icon="ico-money" >
        <div className="row">
          <ProtectedItem allowedPermissions={controleCampoAlternativos('numeroBeneficio')}>
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('numeroBeneficio')}
                error={'numeroBeneficio' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.numeroBeneficio : false}
                touched={props.estadoFormulario.touched}
                label="Número do Benefício de Pensão"
                maxLength="11"
                integer
                value={props.estadoFormulario.requerimento.numeroBeneficio}
                onChange={e => props.handleChange(e, 'numeroBeneficio')}
                required
              />
            </Grid>
            <Grid cols="4 4 4 4">
              {pesquisarNB}
            </Grid>
          </ProtectedItem>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('dataInicioBeneficio')}
              label="Data de Início de Benefício"
              mask={Masks.date}
              required
              value={props.estadoFormulario.requerimento.dataInicioBeneficio}
              onChange={e => props.handleChange(e, 'dataInicioBeneficio')}
              touched={props.estadoFormulario.touched}
              error={!props.estadoFormulario.validadeCampos.dataInicioBeneficio}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('dataInicioPagamentoBeneficio')}
              label="Data de Início de Pagamento"
              onChange={e => props.handleChange(e, 'dataInicioPagamentoBeneficio')}
              mask={Masks.date}
              value={props.estadoFormulario.requerimento.dataInicioPagamentoBeneficio}
              error={'dataInicioPagamentoBeneficio' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataInicioPagamentoBeneficio : false}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
          <Grid cols="3 3 3 3">
            <Input
              disabled={verificaSeCampoDesabilitado('dataCessacaoBeneficio')}
              error={'dataCessacaoBeneficio' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataCessacaoBeneficio : false}
              label="Data de Cessação"
              mask={Masks.date}
              value={props.estadoFormulario.requerimento.dataCessacaoBeneficio}
              onChange={e => props.handleChange(e, 'dataCessacaoBeneficio')}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
          <Grid cols="1 1 1 1">{ botaoAlterarDataCessacao }</Grid>
          <Grid cols="4 4 4 4">
            <Input
              currency
              showMask={false}
              disabled={verificaSeCampoDesabilitado('rendaMensalInicial')}
              label="Renda Mensal Inicial"
              // mask={Masks.currency}
              maxLength="16"
              onChange={e => props.handleChange(e, 'rendaMensalInicial')}
              onKeyUp={e => props.handleKeyUp(e, 'rendaMensalInicial')}
              touched={props.estadoFormulario.touched}
              value={props.estadoFormulario.requerimento.rendaMensalInicial}
              required
              error={!props.estadoFormulario.validadeCampos.rendaMensalInicial}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <ProtectedItem allowedPermissions={controleCampoAlternativos('dataCreditoPagamento')}>
              <Input
                disabled={verificaSeCampoDesabilitado('dataCreditoPagamento')}
                error={'dataCreditoPagamento' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataCreditoPagamento : false}
                mask={Masks.date}
                label="Data de Crédito do Pagamento"
                onChange={e => props.handleChange(e, 'dataCreditoPagamento')}
                value={props.estadoFormulario.requerimento.dataCreditoPagamento}
                touched={props.estadoFormulario.touched}
              />
            </ProtectedItem>
            <ProtectedItem allowedPermissions={controleCampoAlternativos('dataHomologacaoTribunalContas')}>
              <Input
                disabled={verificaSeCampoDesabilitado('dataHomologacaoTribunalContas')}
                error={'dataHomologacaoTribunalContas' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataHomologacaoTribunalContas : false}
                mask={Masks.date}
                label="Data de Homologação no Tribunal de Contas"
                onChange={e => props.handleChange(e, 'dataHomologacaoTribunalContas')}
                value={props.estadoFormulario.requerimento.dataHomologacaoTribunalContas}
                touched={props.estadoFormulario.touched}
              />
            </ProtectedItem>
          </Grid>
          {props.estadoFormulario.exibirCampoUoInss ?
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="UO INSS"
                value={props.estadoFormulario.requerimento.idUOMantenedora}
                touched={props.estadoFormulario.touched}
                required
              />
            </Grid>
          :
            <ProtectedItem allowedPermissions={controleCampoAlternativos('idUOMantenedora')}>
              <Grid cols="4 4 4 4">
                <Input
                  disabled
                  label="UO INSS"
                  value={props.estadoFormulario.requerimento.idUOMantenedora}
                  touched={props.estadoFormulario.touched}
                  required
                />
              </Grid>
            </ProtectedItem>
          }
        </div>
      </DataGrid>
      <Dependentes
        acao={props.estadoFormulario.acao}
        dependentes={[...props.estadoFormulario.requerimento.dependentes]}
        exigencias={props.estadoFormulario.requerimento.exigencias}
        estadoFormulario={props.estadoFormulario.estadoFormulario}
        handleChange={e => props.handleChange(e, 'dependentes')}
        isFetchExigencias={props.estadoFormulario.isFetchExigencias}
        checkIsFetchExigencias={props.checkIsFetchExigencias}
        errosDependentes={props.estadoFormulario.camposDependentesInvalidos}
        validacaoErrosDependentes={props.validacaoErrosDependentes}
        solicitante={props.estadoFormulario.requerimento.solicitante}
        auth={props.auth}
      />
      {props.estadoFormulario.acao === 'novo' ||
      props.estadoFormulario.acao === 'indeferidos' ||
      props.estadoFormulario.acao === 'criado' ||
      habilitarUploadNaConsultaDoRequerimento(props.estadoFormulario.requerimento, props.estadoFormulario.acao, null) ?
        <UploadArquivos
          acao={props.estadoFormulario.acao}
          arquivos={[...props.estadoFormulario.requerimento.arquivos]}
          estadoFormulario={props.estadoFormulario.estadoFormulario}
          handleChange={e => props.handleChange(e, 'arquivos')}
          auth={props.auth}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          tiposDocumentos={props.tiposDocumentos}
          requerimento={props.estadoFormulario.requerimento}
          listaExigencias={props.estadoFormulario.exigenciasOriginais ?
            props.estadoFormulario.exigenciasOriginais : []}
          temBloqueioAtivoContratoDtp={props.temBloqueioAtivoContratoDtp}
        />
      : '' }
      {props.exibirModalDataCessacao ?
        <ModalAlteracaoDataCessacao
          acao={props.estadoFormulario.acao}
          protocolo={props.estadoFormulario.requerimento.protocolo}
          dataCessacaoBeneficio={props.estadoFormulario.requerimento.dataCessacaoBeneficio}
          handleModal={() => props.handleModalAlteraDataCessacao()}
          showModal={props.exibirModalDataCessacao}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          atualizarDataCessacao={props.atualizarDataCessacao}
          estadoFormulario={props.estadoFormulario}
        />
      : '' }
      { calculoCompensacao }
      { documentosProbatorios }
      { resultadoAnalise }
    </React.Fragment>
  );
};

DadosRequerimentoPensao.propTypes = {
  acao: PropTypes.string.isRequired,
  alteraEstadoRequerimento: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  camposCnis: PropTypes.arrayOf(PropTypes.string).isRequired,
  camposCentralService: PropTypes.arrayOf(PropTypes.string).isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleKeyUp: PropTypes.func.isRequired,
  handleSearchButton: PropTypes.func.isRequired,
  handleSearchNBButton: PropTypes.func.isRequired,
  handleChangeDestinatario: PropTypes.func.isRequired,
  handleModalAlteraDataCessacao: PropTypes.func.isRequired,
  exibirModalDataCessacao: PropTypes.bool.isRequired,
  atualizarDataCessacao: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  tiposDocumentos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  validacaoErrosDependentes: PropTypes.func.isRequired,
  checkIsFetchExigencias: PropTypes.func.isRequired,
  atualizarDocumentosProbatorios: PropTypes.func.isRequired,
  temBloqueioAtivoContratoDtp: PropTypes.bool.isRequired,
  handleChangeTipoDocumento: PropTypes.func.isRequired,
  handleChangeFile: PropTypes.func.isRequired,
};

DadosRequerimentoPensao.defaultProps = {
  match: null,
  tiposDocumentos: [],
};

export default DadosRequerimentoPensao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Pensao/DadosRequerimentoPensao.jsx